<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات دسته بندی محصول"
        >
          <b-form
            ref="productcategoryform"
            @submit.prevent
          >
            <b-row>

              <b-col
                class="mt-2 form-size"
                md="8"
              >

                <b-row>

                  <b-col
                    class="image"
                    cols="12"
                  >
                    <b-media class="mb-2">
                      <template #aside>
                        <b-avatar
                          ref="previewEl"
                          :src="Form.Image"
                          size="90px"
                          rounded
                          button
                          @click="$refs.refInputEl.click()"
                        />
                      </template>
                      <input
                        :ref="'refInputEl'"
                        type="file"
                        class="d-none"
                        name="Image"
                        @input="imageRenderer($event)"
                      >
                      <b-row>
                        <b-col md="6">
                          <b-form-group
                            label="عنوان"
                            label-for="Title"
                            class="mb-0"
                          >
                            <b-form-input
                              id="Title"
                              v-model="Form.Title"
                              name="Title"
                              autocomplete="off"
                            />
                          </b-form-group>
                        </b-col>

                        <b-col md="4">
                          <b-form-group
                            label="دسته بندی والد"
                            label-for="ProductCategoryId"
                          >
                            <product-category
                              v-model="Form.ProductCategoryId"
                              :multiple="false"
                              :clearable="true"
                            />
                          </b-form-group>
                        </b-col>

                        <b-col md="2">
                          <b-form-group
                            label="ترتیب"
                            label-for="Sort"
                          >
                            <b-form-input
                              id="Sort"
                              v-model="Form.Sort"
                              name="Sort"
                              type="number"
                              autocomplete="off"
                            />
                          </b-form-group>
                        </b-col>

                      </b-row>
                    </b-media>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="پیوند یکتا"
                      label-for="Slug"
                    >
                      <b-form-input
                        id="Sort"
                        v-model="Form.Slug"
                        name="Slug"
                        autocomplete="off"
                        dir="ltr"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="12"
                    class="mb-50"
                  >
                    <b-form-group>
                      <b-form-checkbox
                        v-model="Form.ShowInHome"
                        name="ShowInHome"
                        value="true"
                        class="custom-control-primary"
                      >
                        در صفحه اصلی نمایش داده شود.
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>

                  <b-col md="12">

                    <b-form-group
                      label="توضیحات"
                      label-for="Description"
                    >
                      <z-quill-editor v-model="Form.Description" />
                    </b-form-group>

                  </b-col>

                  <z-seo v-model="Form" />

                </b-row>

                <b-row>
                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import ProductCategory from '@/tools/productcategory.vue'
import ZQuillEditor from '@/tools/quilleditor.vue'
import ZSeo from '@/tools/seo.vue'

export default {
  name: 'ProductCategoryDetails',
  components: { ZSeo, ZQuillEditor, ProductCategory },
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Image: null,
        Description: null,
        Sort: 0,
      },
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.productcategory.add
      if (this.$route.params.id) {
        url = this.$api.productcategory.update
      }

      const formData = new FormData(this.$refs.productcategoryform)
      formData.append('Id', this.Form.Id)

      if (this.Form.Description) {
        formData.append('Description', this.Form.Description)
      }

      formData.append('SliderSortBy', this.Form.SliderSortBy)

      if (this.Form.ProductCategoryId) {
        formData.append('ProductCategoryId', this.Form.ProductCategoryId)
      }

      this.loading = true
      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    sliderImageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.SliderImage = fileReader.result
      }
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.productcategory.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
  },
}
</script>

<style scoped>
.image .media-body {
    align-self: flex-end;
}

.image .form-group {
    margin-bottom: 0px;
}

.slider .media-body {
    align-self: flex-end;
}

.slider .form-group {
    margin-bottom: 0px;
}
</style>
